import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { environment } from '@environments/environment';

@Pipe({
  name: 'isGmbEnabled'
})
export class IsGmbEnabledPipe implements PipeTransform, OnDestroy {

  _subs: Subscription = new Subscription()
  private gmbEnabled = false;

  constructor(private locationFacadeService: LocationsFacadeService) {
    this._subs.add(
      this.locationFacadeService.getCurrentLocation$().subscribe(location => {
        this.gmbEnabled = environment.gmb_enabled && (
          environment.gmb_whitelist.length == 0
            || environment.gmb_whitelist.some(item => item == location.id)
        );
      })
    );
  }

  transform(condition: boolean | null): boolean {
    return this.gmbEnabled && condition;
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe()
  }

}
